<template>
  <g>
    <path
      d="M1 14.0909L8 2L15 14.0909H1ZM2.65455 13.1364H13.3455L8 3.90909L2.65455 13.1364ZM8.06642 12.2295C8.20244 12.2295 8.31553 12.1835 8.40568 12.0915C8.49583 11.9995 8.54091 11.8855 8.54091 11.7495C8.54091 11.6135 8.49491 11.5004 8.4029 11.4102C8.31088 11.3201 8.19686 11.275 8.06085 11.275C7.92483 11.275 7.81174 11.321 7.72159 11.413C7.63144 11.505 7.58636 11.619 7.58636 11.7551C7.58636 11.8911 7.63237 12.0042 7.72437 12.0943C7.81639 12.1845 7.93041 12.2295 8.06642 12.2295ZM7.58636 10.4636H8.54091V6.9H7.58636V10.4636Z"
      :fill="fill"
    />
  </g>
</template>

<script>
export default {
  props: {
    fill: {
      type: String,
      required: true
    }
  }
};
</script>
